/*
 * Identifie cet onglet/session (pas l'utilisateur) : un même compte peut avoir la même conversation ouverte dans
 * plusieurs onglets, et un onglet ne doit pas se traiter lui-même comme "un autre spectateur" (ex: indicateur de
 * saisie, écho de ses propres actions -- cf. ADR 0003 décision 4).
 *
 * Volontairement isolé dans son propre module : il est consommé à la fois par socketService (header de connexion
 * STOMP) et par api.js (header HTTP X-Client-Id). Le faire porter par socketService obligerait api.js, qui est
 * importé par toute l'application, à tirer le client STOMP et le store Vuex pour une simple chaîne.
 */
export default `${Date.now()}-${Math.random().toString(36).slice(2)}`;
